import React, { Component } from 'react'

export default class home extends Component {
    render() {
        return (
            <div style={{ marginTop: '100px', fontSize: '30px' }}>
                Wellcome Home!
            </div>
        )
    }
}
